import { render } from "./MediaPredict.vue?vue&type=template&id=1c2f7b98&scoped=true"
import script from "./MediaPredict.vue?vue&type=script&lang=js"
export * from "./MediaPredict.vue?vue&type=script&lang=js"

import "./MediaPredict.vue?vue&type=style&index=0&id=1c2f7b98&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/production-allsports-2/production-as-fe-fj-SSR/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c2f7b98"]])

export default __exports__